const HAS_LETTER_OR_DIGIT = /[\p{L}\p{N}]/u;

// Names arrive as "Last, First" with stray spacing, so tokens that are only punctuation are skipped.
export function initials(name: string): string {
    return name
        .split(/\s+/)
        .map((token) => token.replace(/,+$/, ''))
        .filter((token) => HAS_LETTER_OR_DIGIT.test(token))
        .slice(0, 2)
        .map((token) => token[0])
        .join('')
        .toUpperCase();
}
